module.exports = __webpack_public_path__ + "img/chengjiao.d495e6f5.png";